import AdminApplications from "../../components/Admin/AdminApplications";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import { applicationStatusMap } from "../../config/applicationStatusConfig";

const CancelApplications = () => {
  return (
    <DashboardLayout pageTitle="Application" mainClass="p-6">
      <AdminApplications
        title="Cancel Applications"
        status={[applicationStatusMap?.rejected]}
        stage={null}
      />
    </DashboardLayout>
  );
};

export default CancelApplications;
